import { PAYMENTS_URL } from '@ordermentum/ui-constants';
import React from 'react';
import useSWRImmutable from 'swr/immutable';
import { Input } from '../../../atoms/Input';
import { fetcher } from '../../../swr/fetchers';

type Props = {
  value: string;
  error?: string;
  onChange: (tag: string, newValue: string) => void;
};

type BSBResponse = {
  name: string;
};

const BSBInput = (props: Props) => {
  const { value, error, onChange } = props;
  const { data: bsbInformation } = useSWRImmutable<BSBResponse>(
    value.length >= 6 ? `${PAYMENTS_URL}/v1/validate/bsb?value=${value}` : null,
    fetcher()
  );
  return (
    <>
      <Input
        isFuturo
        tag="bsb"
        inputLabel="BSB"
        type="number"
        size="max"
        value={value}
        hasError={!!error}
        errorLabel={error}
        onChange={onChange}
      />
      {bsbInformation?.name && (
        <p className="text-body-small text-subtle">{bsbInformation.name}</p>
      )}
    </>
  );
};
export default BSBInput;
